module.exports = __webpack_public_path__ + "static/media/ic_video.3272d4bc.svg";